import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../assets/images/whiteSheep/bg1.png'
import _imports_1 from '../../assets/images/whiteSheep/bg2.png'
import _imports_2 from '../../assets/images/whiteSheep/bg3.png'
import _imports_3 from '../../assets/images/whiteSheep/bg4.png'


const _hoisted_1 = {
  id: "picbookContainer",
  class: "picbook-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "picbook-pagination-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "video-panel",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClickPlayBtn && _ctx.handleClickPlayBtn(...args)))
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "vlayer" }, null, -1)),
      _createElementVNode("img", {
        class: _normalizeClass(['player', _ctx.routeName==='studyReport'?'playerWidth':'']),
        src: _ctx.playBtnImgUrl,
        alt: "播放"
      }, null, 10, _hoisted_2)
    ], 512), [
      [_vShow, _ctx.isShowPlayBtnOverlay]
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.picbookTotalPages, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item,
          class: "picbook-pagination-item",
          style: _normalizeStyle(item === _ctx.currentPicbookPageNo + 1 ? 'opacity: 1;' : '')
        }, null, 4))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: "picbook-bg",
      style: _normalizeStyle(_ctx.currentPicbookPageNo === 0 ? 'visibility: visible;' : '')
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("img", {
        class: "picbook-bg-image",
        src: _imports_0
      }, null, -1)
    ]), 4),
    _createElementVNode("div", {
      class: "picbook-bg",
      style: _normalizeStyle(_ctx.currentPicbookPageNo === 1 ? 'visibility: visible;' : '')
    }, _cache[3] || (_cache[3] = [
      _createElementVNode("img", {
        class: "picbook-bg-image",
        src: _imports_1
      }, null, -1)
    ]), 4),
    _createElementVNode("div", {
      class: "picbook-bg",
      style: _normalizeStyle(_ctx.currentPicbookPageNo === 2 ? 'visibility: visible;' : '')
    }, _cache[4] || (_cache[4] = [
      _createElementVNode("img", {
        class: "picbook-bg-image",
        src: _imports_2
      }, null, -1)
    ]), 4),
    _createElementVNode("div", {
      class: "picbook-bg",
      style: _normalizeStyle(_ctx.currentPicbookPageNo === 3 ? 'visibility: visible;' : '')
    }, _cache[5] || (_cache[5] = [
      _createElementVNode("img", {
        class: "picbook-bg-image",
        src: _imports_3
      }, null, -1)
    ]), 4)
  ]))
}